import type { BrowseSort } from "@/lib/browse/browseFilter";

/**
 * Browse's sort choices, in the order they are offered.
 *
 * `BrowseSortControl` offers these in the shared `MenuPill` sheet.
 *
 * `a11y` is the spoken and queried form. It is a full sentence because "Name A–Z" heard out of
 * context does not say it sorts. The web e2e specs address the options by these strings.
 */
export const SORTS: { value: BrowseSort; label: string; a11y: string; }[] = [
  { value: "featured", label: "Recently added", a11y: "Sort by recently added" },
  { value: "price-asc", label: "Lowest price", a11y: "Sort by lowest price" },
  { value: "price-desc", label: "Highest price", a11y: "Sort by highest price" },
  { value: "name", label: "Name A–Z", a11y: "Sort by name" },
];

/** Returns the choice matching `sort`, falling back to the first (featured, the default). */
export const sortOption = (sort: BrowseSort) =>
  SORTS.find((option) => option.value === sort) ?? SORTS[0];
